<template>
  <header class="component">
    <div class="menu" @click="operationMenu">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 520 520"
        version="1.1"
        v-if="flg === 2"
      >
        <path
          d="M359.123,146.863c-3.903,-3.903 -10.239,-3.903 -14.142,0l-197.99,197.99c-3.903,3.902 -3.903,10.239 0,14.142l14.142,14.142c3.903,3.903 10.24,3.903 14.142,0l197.99,-197.99c3.903,-3.902 3.903,-10.239 0,-14.142l-14.142,-14.142Z"
        />
        <path
          d="M373.265,358.995c3.903,-3.903 3.903,-10.24 0,-14.142l-197.99,-197.99c-3.902,-3.903 -10.239,-3.903 -14.142,0l-14.142,14.142c-3.903,3.903 -3.903,10.24 0,14.142l197.99,197.99c3.903,3.903 10.239,3.903 14.142,0l14.142,-14.142Z"
        />
      </svg>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 520 520"
        version="1.1"
        v-else
      >
        <path
          d="M410,330c0,-5.519 -4.481,-10 -10,-10l-280,0c-5.519,0 -10,4.481 -10,10l0,20c0,5.519 4.481,10 10,10l280,0c5.519,0 10,-4.481 10,-10l0,-20Z"
        />
        <path
          d="M410,240c0,-5.519 -4.481,-10 -10,-10l-280,0c-5.519,0 -10,4.481 -10,10l0,20c0,5.519 4.481,10 10,10l280,0c5.519,0 10,-4.481 10,-10l0,-20Z"
        />
        <path
          d="M410,150c0,-5.519 -4.481,-10 -10,-10l-280,0c-5.519,0 -10,4.481 -10,10l0,20c0,5.519 4.481,10 10,10l280,0c5.519,0 10,-4.481 10,-10l0,-20Z"
        />
      </svg>
    </div>
    <div
      class="content"
      :class="{ content_open: flg === 2, content_close: flg === 1 }"
      @click="flg = 1"
    >
      <div>
        <router-link to="/product">商品一覧</router-link>
        <router-link to="/company-information">会社概要</router-link>
      </div>
    </div>
    <h1 class="title" v-if="$route.name === 'home'" @click="transitionRoute">
      マルキ鈴菊商店
    </h1>
    <p class="title" v-else @click="transitionRoute">マルキ鈴菊商店</p>
  </header>
</template>

<script>
export default {
  data: () => ({
    flg: 0
  }),
  mounted() {
    document.addEventListener("mousewheel", this.scroll, { passive: false });
    document.addEventListener("touchmove", this.scroll, { passive: false });
  },
  methods: {
    operationMenu() {
      switch (this.flg) {
        case 0:
          this.flg = 2;
          break;
        case 1:
          this.flg = 2;
          break;
        case 2:
          this.flg = 1;
          break;
        default:
          this.flg = 0;
          break;
      }
    },
    transitionRoute() {
      if (this.$route.name !== "home") {
        this.$router.push("/");
      }
    },
    scroll(event) {
      if (this.flg === 2) {
        event.preventDefault();
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("mousewheel", this.scroll, { passive: false });
    document.removeEventListener("touchmove", this.scroll, { passive: false });
  }
};
</script>

<style lang="scss" scoped>
@keyframes content-open {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100vw);
  }
}
@keyframes content-close {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(0);
  }
}
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 64px;
  display: table;
  box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.4);
  background-color: #fff;
  svg {
    fill-rule: evenodd;
    clip-rule: evenodd;
    stroke-linejoin: round;
    stroke-miterlimit: 2;
  }
  .menu {
    position: absolute;
    width: 64px;
    height: 64px;
    z-index: 99;
  }
  .content {
    position: fixed;
    top: 0;
    left: -100vw;
    // right: 100vw;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 97;
    div {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      max-width: 240px;
      transform: translate(-50%, -50%);
      a {
        font-size: 1.25em;
        text-align: center;
        margin: 0.5em 0;
      }
    }
  }
  .content_open {
    animation: content-open 0.3s ease-in forwards;
  }
  .content_close {
    animation: content-close 0.3s ease-out forwards;
  }
  .title {
    display: table-cell;
    font-size: 1.25em;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    width: 100vw;
    z-index: 98;
  }
}
</style>
